import createCache from '@emotion/cache';

const emotionCache = createCache({
    key: 'next',
});

export default emotionCache;
